import { useTranslation } from 'react-i18next';
// '@mui
import { enUS, frFR, esES } from '@mui/material/locale';

// ----------------------------------------------------------------------

const LANGS = [ 
  {
    label: 'Français',
    value: 'fr',
    systemValue: frFR,
    icon: '/static/assets/icons/ic_flag_fr.svg',
  },
  {
    label: 'Kreyol ayisyen',
    value: 'ht',
    systemValue: enUS,
    icon: '/static/assets/icons/ic_flag_ht.svg',
  },
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
    icon: '/static/assets/icons/ic_flag_en.svg',
  },
  {
    label: 'Spanish',
    value: 'es',
    systemValue: esES,
    icon: '/static/assets/icons/ic_flag_es.svg',
  },
];

export default function useLocales() {
  const { i18n, t: translate } = useTranslation();
  const langStorage = localStorage.getItem('i18nextLng');
  const currentLang = LANGS.find((_lang) => _lang.value === langStorage) || LANGS[1];

  const handleChangeLanguage = (newlang) => {
    i18n.changeLanguage(newlang);
  };

  return {
    onChangeLang: handleChangeLanguage,
    translate,
    currentLang,
    allLang: LANGS,
  };
}
